export { default as LoyaltyGreetingWidget, GreetingVariant } from './loyalty-greeting-widget';
